// importer toutes les images dans le dossier assets
import ImagePair from "../models/imagePair"
import StoreService from "./store"

class ImageService {
    private static instance: ImageService

    /**
     *ImageMap tableau de ImagePair qui va contenir toutes les images avec leurs keys
     */
    private ImageMap: Array<ImagePair> = []

    /**
     * Récuperation de l'instance
     */
    public static getInstance(): ImageService {
        if (!this.instance) {
            this.instance = new ImageService()
        }
        return this.instance
    }

    setImageMap(map: Array<ImagePair>): void {
        this.ImageMap = map
    }

    getImageMap(): Array<ImagePair> {
        return this.ImageMap
    }

    /**
     * Retourne l'import de l'image qui corresponde à la clé donnée
     * @param key clé du pointeur de l'image à récupérer
     */
    getImage(key: string): string {
        let result = key
        if (key && key.indexOf("blob") === -1) {
            this.ImageMap.forEach((pair: ImagePair) => {
                if (pair.key === key) result = pair.import
            })
        }
        return result
    }

    /**
     * Retourne l'import de l'image qui corresponde à la clé donnée à partir de la ged
     * @param key clé du pointeur de l'image à récupérer
     */
    static async resolveImage(key: string): Promise<string | null> {
        let result = null
        if (key.indexOf("#ged.") > -1) {
            try {
                result = await StoreService.getInstance().get(
                    key.replace("#ged", "ged")
                )
            } catch (e: any) {
                return null
            }
        }
        return result
    }

    static imageLimitSize(): any {
        if (process.env.IMAGE_SIZE_LIMITL) return process.env.IMAGE_SIZE_LIMIT
        return 2242880
    }
}

export default ImageService
